import { z } from 'zod';
const agentFieldRules = z.registry();
export function hiddenFromAgent(schema, reason) {
    const copy = schema.clone();
    agentFieldRules.add(copy, { kind: 'hidden', reason });
    return copy;
}
export function limitedForAgent(schema, reason, refuses) {
    const copy = schema.clone();
    agentFieldRules.add(copy, { kind: 'limited', reason, refuses });
    return copy;
}
export function agentFieldRule(schema) {
    let current = schema;
    for (;;) {
        const rule = agentFieldRules.get(current);
        if (rule)
            return rule;
        if (current instanceof z.core.$ZodOptional ||
            current instanceof z.core.$ZodExactOptional ||
            current instanceof z.core.$ZodNullable ||
            current instanceof z.core.$ZodDefault ||
            current instanceof z.core.$ZodPrefault ||
            current instanceof z.core.$ZodCatch ||
            current instanceof z.core.$ZodReadonly) {
            current = current._zod.def.innerType;
        }
        else {
            return undefined;
        }
    }
}
//# sourceMappingURL=agentHidden.js.map